const AUTH_API_URL = process.env.NEXT_PUBLIC_AUTH_API_URL;

const handleErrors = async (response) => {
    const _response = response.clone();
    const resp = await _response.json();

    if (!response.ok) {
        // process.env.NODE_ENV === "development" && console.log("%c handleErrors ", "background: #F00;", response, resp);
        throw Error(resp?.message || response.status, { cause: resp });
    }
    return response;
};

export const getFromAPI = async (URL, signal, token) => {
    let options = { signal };
    if (token) {
        options.headers = { Authorization: `Bearer ${token}` };
    }
    const DATA = await fetch(URL, options)
        .then(async (response) => {
            return await handleErrors(response);
        })
        .then(async (response) => {
            // console.log(` --------------------------`)
            // console.log(`getFromAPI .then ~ response:`, response)
            // console.log(` --------------------------`)

            let result;
            result = await response.json();
            if (!response.ok) {
            }
            return result;
        })

        .catch((err) => {
            const _err = {
                ok: false,
                message: err.message,
                ...(err?.cause || {}),
            };

            // return err?.cause || err;
            return _err;
        });
    return DATA;
};

export const postToAPI = async (URL, data = {}, signal, token) => {
    let options = {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
            "Content-Type": "application/json",
        },
        redirect: "follow",
        referrerPolicy: "no-referrer",
        body: JSON.stringify(data),
        signal,
    };
    if (token) {
        options.headers.Authorization = `Bearer ${token}`;
    }
    const DATA = await fetch(URL, options)
        .then(async (response) => {
            return await handleErrors(response);
        })
        .then(async (response) => {
            let result;
            result = await response.json();
            if (!response.ok) {
            }
            return result;
        })
        .catch((err) => {
            const _err = {
                ok: false,
                message: err.message,
                ...(err?.cause || {}),
            };

            // return err?.cause || err;
            return _err;
        });
    return DATA;
};

export const wrongParams = (description = "") => {
    return {
        message: {
            type: "Error",
            text: `Wrong parameters for request${description ? ` (${description})` : ""}`,
        },
    };
};
